import { useGLTF } from "@react-three/drei";
import { useEffect, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

interface ClickInfo {
  objectName: string;
  hitPoint: { x: number; y: number; z: number };
  localPosition: { x: number; y: number; z: number };
  worldPosition: { x: number; y: number; z: number };
  clientX: number;
  clientY: number;
}

interface DrawerState {
  isOpen: boolean;
  targetPosition: THREE.Vector3;
  closedPosition: THREE.Vector3;
  openPosition: THREE.Vector3;
}

const Scene = function Scene({
  onClickObject,
  giftComponentsNames,
  giftOpen,
}: {
  onClickObject?: (info: ClickInfo) => void;
  giftComponentsNames: string[];
  giftOpen: boolean;
}) {
  const { scene } = useGLTF("/models/scene_compressed.glb") as any;
  const giftStatesRef = useRef<Map<string, DrawerState>>(new Map());

  useEffect(() => {
    scene.traverse((child: THREE.Object3D) => {
      // use giftComponentsNames array to check for matching names
      if (
        giftComponentsNames.some((name) =>
          child.name.toLowerCase().includes(name),
        )
      ) {
        const closedPos = child.position.clone();
        const openPos = closedPos.clone();
        // openPos.y -= 500;

        giftStatesRef.current.set("gift", {
          isOpen: giftOpen,
          targetPosition: closedPos.clone(),
          closedPosition: closedPos,
          openPosition: openPos,
        });
      }
    });
  }, [scene, giftComponentsNames, giftOpen]);

  useFrame(() => {
    const giftState = giftStatesRef.current.get("gift");
    if (!giftState) return;

    giftState.isOpen = giftOpen;

    scene.traverse((child: THREE.Object3D) => {
      const childNameLower = child.name.toLowerCase();

      if (giftComponentsNames.some((name) => childNameLower.includes(name))) {
        console.log(
          `Setting visibility of ${child.name} to ${!giftState.isOpen}`,
        );
        child.visible = !giftState.isOpen;
      }
    });
  });

  return (
    <primitive
      object={scene}
      scale={2.5}
      position={[0, 0, -20]}
      onClick={(e: any) => {
        e.stopPropagation();

        const worldPos = new THREE.Vector3();
        e.object.getWorldPosition(worldPos);
        console.log("🌍 World position:", worldPos);

        if (onClickObject) {
          onClickObject({
            objectName: e.object.name,
            hitPoint: { x: e.point.x, y: e.point.y, z: e.point.z },
            localPosition: {
              x: e.object.position.x,
              y: e.object.position.y,
              z: e.object.position.z,
            },
            worldPosition: { x: worldPos.x, y: worldPos.y, z: worldPos.z },
            clientX: e.clientX,
            clientY: e.clientY,
          });
        }
      }}
    />
  );
};

export default Scene;
